import { Clock, ShieldCheck, ClipboardCheck, Warehouse, Settings, Truck, Building, BadgeIndianRupee } from 'lucide-react';
import { whyChooseUs } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = {
  Clock, ShieldCheck, ClipboardCheck, Warehouse, Settings, Truck, Building, BadgeIndianRupee
};

export const WhyChooseUs = () => {
  const [ref, isInView] = useInView();

  return (
    <section className="py-20 lg:py-28 bg-[hsl(210,20%,98%)]" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className={`text-center mb-14 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="section-divider" />
            <span className="text-sm font-semibold text-ind-red-600 uppercase tracking-wider">Why Choose Us</span>
            <div className="section-divider" />
          </div>
          <h2 className="font-heading font-extrabold text-navy-950 text-3xl lg:text-4xl mb-3">
            Why V.R. Enterprises?
          </h2>
          <p className="text-navy-500 text-base max-w-xl mx-auto">
            Four decades of trust, quality, and performance in industrial manufacturing.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {whyChooseUs.map((item, idx) => {
            const IconComponent = iconMap[item.icon] || ShieldCheck;
            return (
              <div
                key={item.title}
                className={`card-hover group bg-white rounded-xl border border-navy-100 p-6 ${
                  isInView ? 'animate-fade-in-up' : 'opacity-0'
                }`}
                style={{ animationDelay: `${idx * 0.08}s` }}
              >
                <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center mb-4 group-hover:bg-ind-red-50 border border-navy-100 group-hover:border-ind-red-100 transition-colors duration-300">
                  <IconComponent className="w-5 h-5 text-navy-600 group-hover:text-ind-red-600 transition-colors duration-300" />
                </div>
                <h3 className="font-heading font-bold text-navy-900 text-sm mb-2">{item.title}</h3>
                <p className="text-xs text-navy-500 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
